import { createContext, useContext, useState, useEffect } from 'react';
import AuthService from '../services/auth.service';
import toast from 'react-hot-toast';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        checkSession().catch(console.error);
    }, []);

    const checkSession = async () => {
        try {

            const token = localStorage.getItem('access_token');
            if (token) {
                const response = await AuthService.getCurrentUser();
                setUser(response.data);
            }
        } catch (error) {
            console.error('Session has expired expired or invalid');
            AuthService.logout();
        } finally {
            setLoading(false);
        }
    };

    const login = async (email, password) => {
        try {
            const response = await AuthService.login(email, password);
            if (response.user) {
                setUser(response.user);
            } else {
                await checkSession();
            }
            toast.success('Logged in successfully');
            return true;
        } catch (error) {
            console.error(error);
            toast.error('Invalid credentials');
            return false;
        }
    };

    const register = async (data) => {
        try {
            await AuthService.register(data);
            toast.success('Registration successful. Please login.');
            return true;
        } catch (error) {
            console.error(error);
            const msg = error.response?.data?.email?.[0] || 'Registration failed';
            toast.error(msg);
            return false;
        }
    };

    const checkUser = async (phone, email) => {
        try {
            await AuthService.checkUser(phone, email);
            return { success: true };
        } catch (error) {
            console.error(error);
            const msg = error.response?.data?.email?.[0] || error.response?.data?.phone?.[0] || 'Validation error';
            toast.error(msg);
            return { success: false, message: msg };
        }
    };

    const sendOtp = async (phone, email, firstName) => {
        try {
            const res = await AuthService.sendOtp(phone, email, firstName);
            return { success: true, message: res.data?.message || 'OTP Sent' };
        } catch (error) {
            console.error(error);
            const msg = error.response?.data?.error || error.response?.data?.message || 'Failed to send OTP';
            toast.error(msg);
            return { success: false, message: msg };
        }
    };

    const verifyOtp = async (phone, email, otp) => {
        try {
            const res = await AuthService.verifyOtp(phone, email, otp);
            return res.data?.status === true;
        } catch (error) {
            console.error(error);
            const msg = error.response?.data?.error || 'Failed to verify OTP';
            toast.error(msg);
            return false;
        }
    };

    const logout = () => {
        AuthService.logout();
        setUser(null);
        toast.success('Logged out');
        window.location.href = '/login';
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, sendOtp, verifyOtp, checkUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
